const AI = 'AI'
const CONTENT = 'Content'
const DESIGN = 'Design'
const AUDIO = 'Audio'
const SETTINGS = 'Settings'
const SPELL_CHECKER = 'Spell Checker'
const TEMPLATES = 'Templates'

const TAB_NAMES = {
  AI, CONTENT, DESIGN, AUDIO, SETTINGS, SPELL_CHECKER, TEMPLATES,
}
const AI_HEADER = 'Edit with AI'
const CONTENT_HEADER = ['Type', 'Content', 'Templates']
const DESIGN_HEADER = 'Design'
const AUDIO_HEADER = ['Slide', 'Presentation']
const SETTINGS_HEADER = 'Settings'

const ALL_TABS = {
  AI: {
    name: AI,
    icon: 'phosphor-Sparkle',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: AI_HEADER,
  },
  CONTENT: {
    name: CONTENT,
    icon: 'phosphor-PencilSimpleLine',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: CONTENT_HEADER,
  },
  DESIGN: {
    name: DESIGN,
    icon: 'phosphor-Palette',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: DESIGN_HEADER,
  },
  AUDIO: {
    name: AUDIO,
    icon: 'phosphor-MusicNotesSimple',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: AUDIO_HEADER,
  },
  SETTINGS: {
    name: SETTINGS,
    icon: 'phosphor-Gear',
    iconWidth: 24,
    iconHeight: 24,
    iconViewBox: '0 0 24 24',
    header: SETTINGS_HEADER,
  },
}

const SUB_TABS = {
  [TAB_NAMES.DESIGN]: {
    PRESENTATION: 0,
    SLIDES: 1,
  },
}

export default {
  TAB_NAMES,
  ALL_TABS,
  SUB_TABS,
}
